import { useState } from "react";
import {
    FaFilePdf,
    FaFileWord,
    FaFileExcel,
    FaFileImage,
    FaFileAudio,
    FaFileVideo,
    FaFileArchive,
    FaFileAlt,
    FaFileCode,
    FaFilePowerpoint,
    FaFileCsv,
} from "react-icons/fa";
import { FaPaperclip } from "react-icons/fa6";

// Helper: returns an icon based on file extension
const getFileIcon = (filename, size = 15) => {
    const ext = (filename || "").split('.').pop().toLowerCase();
    if (["pdf"].includes(ext)) return <FaFilePdf size={size} className="text-red-500" />;
    if (["doc", "docx"].includes(ext)) return <FaFileWord size={size} className="text-[#5652CF]" />;
    if (["xls", "xlsx"].includes(ext)) return <FaFileExcel size={size} className="text-green-500" />;
    if (["ppt", "pptx"].includes(ext)) return <FaFilePowerpoint size={size} className="text-orange-500" />;
    if (["csv"].includes(ext)) return <FaFileCsv size={size} className="text-teal-500" />;
    if (["txt", "md", "markdown"].includes(ext)) return <FaFileAlt size={size} className="text-gray-500" />;
    if (["png", "jpg", "jpeg", "gif", "bmp", "svg", "ico"].includes(ext)) return <FaFileImage size={size} className="text-yellow-500" />;
    if (["zip", "rar", "7z", "tar", "gz"].includes(ext)) return <FaFileArchive size={size} className="text-gray-500" />;
    if (["mp3", "wav", "ogg", "flac"].includes(ext)) return <FaFileAudio size={size} className="text-purple-500" />;
    if (["mp4", "avi", "mkv", "mov", "wmv"].includes(ext)) return <FaFileVideo size={size} className="text-indigo-500" />;
    if (["js", "jsx", "ts", "tsx", "html", "css", "json", "xml", "py"].includes(ext)) return <FaFileCode size={size} className="text-green-700" />;
    // default
    return <FaFileAlt size={size} className="text-gray-500" />;
};


const AttachmentItem = ({ file }) => {

    const [hovered, setHovered] = useState(false);

    return (

        <div
            className="text-gray-500 w-40 h-10 py-3 border p-2 rounded-lg shadow-md cursor-pointer inline-flex items-center justify-center"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >

            {hovered ? (
                <div className="flex gap-4 items-center justify-center w-full">

                    <button className="ml-2 text-gray-600 hover:text-red-400">&times;</button>

                </div>
            ) : (
                <div className="flex items-center space-x-2 w-full">
                    <div className="w-8 h-8 flex items-center justify-center">
                        {getFileIcon(file.name.split(".").pop().toLowerCase())} {/* Handle both cases */}
                    </div>
                    <span className="truncate text-sm font-medium">
                        {file.name} {/* Handle both cases */}
                    </span>
                </div>
            )}

        </div>

    );
};

export { getFileIcon };
export default AttachmentItem;